import { IconProps } from '../icon-props-interface';
import '../icons.scss';

export const IconNextPage = ({ color = 'var(--color-primary-1)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.25 1.73039L5.21419 5L1.25 8.26961L1.25 1.73039Z" fill={color} stroke={color} />
        </svg>

    </div>
);

export default IconNextPage;
